type CharacterCounterProps = {
  charLimit?: number;
  charsLength?: number;
  isTextOverflow?: boolean;
};

export function CharacterCounter({ charLimit, charsLength, isTextOverflow }: CharacterCounterProps) {
  let numerator = '0';
  const denominator = charLimit?.toLocaleString('en', { useGrouping: true });

  if (charLimit && charsLength) {
    const numberNumerator = isTextOverflow ? charLimit - charsLength : charsLength;
    numerator = numberNumerator?.toLocaleString('en', { useGrouping: true });
  }

  return charLimit ? (
    <span>
      {numerator} / {denominator}
    </span>
  ) : null;
}
